(function () {
  var d = document,
      root = d.documentElement;

  var still =
    window.matchMedia &&
    matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $$ = function (s, c) {
    return [].slice.call(
      (c || d).querySelectorAll(s)
    );
  };


  /* =========================================
     REVEAL
  ========================================= */

  var io = null;

  if ('IntersectionObserver' in window && !still) {

    root.classList.add('l3Js');

    io = new IntersectionObserver(
      function (es) {

        es.forEach(function (e) {

          if (e.isIntersecting) {

            e.target.classList.add('is-in');

            io.unobserve(e.target);

          }

        });

      },
      {
        rootMargin: '0px 0px -6% 0px'
      }
    );

    $$('.l3Rv').forEach(function (el) {
      io.observe(el);
    });

  } else {

    $$('.l3Rv').forEach(function (el) {
      el.classList.add('is-in');
    });

  }


  /* =========================================
     FRAME SEQUENCER
  ========================================= */

  function frames(host, opts) {

   var allFrames = $$('.l3Frame', host),
    isDesktop = window.matchMedia('(min-width: 750px)'),
    fs = [],
    i = -1,
    t = null,
    running = false;


        function updateFrames() {
        fs = allFrames.filter(function (f) {
          if (f.classList.contains('desk-image')) {
            return isDesktop.matches;
          }

          if (f.classList.contains('mob-image')) {
            return !isDesktop.matches;
          }

          return true;
        });
      }

    updateFrames();
    function show(n) {

      i = (n + fs.length) % fs.length;

      fs.forEach(function (f, k) {

        var on = k === i;

        f.classList.toggle(
          'is-on',
          on
        );

        var v = f.querySelector('video');

        if (v) {

          if (on) {

            try {
              v.currentTime = 0;
              v.play();
            } catch (_) {}

          } else {

            v.pause();

          }

        }

      });

      if (opts.onShow) {
        opts.onShow(i);
      }

    }


    function wait() {

      var v =
        opts.clip &&
        fs[i] &&
        fs[i].querySelector('video');

      return (
        v &&
        isFinite(v.duration) &&
        v.duration > 0
      )
        ? Math.max(
            1500,
            v.duration * 1000 - 450
          )
        : opts.dur;

    }


    function tick() {

      show(i + 1);

      if (
        opts.loop ||
        i < fs.length - 1
      ) {

        t = setTimeout(
          tick,
          wait()
        );

      } else {

        running = false;

        if (opts.onEnd) {
          opts.onEnd();
        }

      }

    }


    return {

      start: function (from) {

        clearTimeout(t);

        running = true;

        show(
          from == null
            ? (i < 0
                ? (opts.start || 0)
                : i)
            : from
        );

        if (!still) {
          t = setTimeout(
            tick,
            wait()
          );
        }

      },


      stop: function () {

        clearTimeout(t);

        running = false;

        fs.forEach(function (f) {

          var v =
            f.querySelector('video');

          if (v) {
            v.pause();
          }

        });

      },


      go: function (n) {

        clearTimeout(t);

        running = false;

        show(n);

      },


      get running() {
        return running;
      }

    };

  }


  /* =========================================
     HERO HEIGHT
  ========================================= */
function heroFit() {
  var h = d.querySelector('.l3Hero');

  if (!h || h.offsetParent === null) {
    return;
  }

  var top = h.getBoundingClientRect().top + scrollY;
  var isMobile = innerWidth <= 749;

  h.style.setProperty(
    '--l3HeroH',
    Math.max(
      isMobile ? 350 : 520,
      Math.round(innerHeight - top)
    ) + 'px'
  );

  }


  heroFit();

  addEventListener(
    'load',
    heroFit
  );

  var rz = null;

  addEventListener(
    'resize',
    function () {

      clearTimeout(rz);

      rz = setTimeout(
        heroFit,
        120
      );

    }
  );


  /* =========================================
     HERO BRAND FILM
  ========================================= */

  var hero =
    d.querySelector('.l3Hero');

  var film = null;

  if (hero) {

    var ticks =
      $$('.l3Ticks i', hero);

    var DUR = 4400;

    var filmEl =
      hero.querySelector('.l3Film');

    film = frames(
      hero,
      {
        dur: DUR,
        clip: true,
        loop: true,
        start: 0,

        onShow: function (n) {

          if (
            filmEl.classList.contains(
              'is-first'
            ) &&
            n !== 0
          ) {

            filmEl.classList.remove(
              'is-first'
            );

          }


          ticks.forEach(
            function (tk, k) {

              tk.classList.remove(
                'is-on'
              );

              tk.classList.toggle(
                'is-done',
                k < n
              );

              void tk.offsetWidth;

              if (
                k === n &&
                !still
              ) {

                tk.classList.add(
                  'is-on'
                );

              }

            }
          );


          if (n === 0) {

            ticks.forEach(
              function (tk, k) {

                if (k > 0) {

                  tk.classList.remove(
                    'is-done'
                  );

                }

              }
            );

          }

        }

      }
    );

    hero.style.setProperty(
      '--dur',
      DUR + 'ms'
    );

  }


  /* =========================================
     COUNT UP
  ========================================= */

  function countUp(el) {

    var raw =
      el.getAttribute('data-n');

    var target =
      parseInt(
        raw.replace(/\D/g, ''),
        10
      );

    var suf =
      raw.replace(
        /[\d,]/g,
        ''
      );

    var comma =
      raw.indexOf(',') > -1;


    if (still) {

      el.textContent = raw;

      return;

    }


    var t0 = null;


    function f(ts) {

      if (!t0) {
        t0 = ts;
      }

      var p =
        Math.min(
          1,
          (ts - t0) / 1400
        );

      var v =
        Math.round(
          target *
          (
            1 -
            Math.pow(
              1 - p,
              3
            )
          )
        );


      el.textContent =
        (
          comma
            ? v.toLocaleString('en-IN')
            : v
        ) + suf;


      if (p < 1) {

        requestAnimationFrame(f);

      } else {

        el.textContent = raw;

      }

    }


    requestAnimationFrame(f);

  }


  /* =========================================
     JOURNEY
  ========================================= */

  var jr =
    d.querySelector('.l3Jr__stage');

  var jrSeq = null;

  if (jr) {

    var rail =
      d.querySelector('.l3Rail');

    var nodes =
      $$('.l3Node', rail);

    var pills =
      $$('.l3Pill__i');

    var words =
      $$('.l3Jr__word');


    jrSeq = frames(
      jr,
      {
        dur: 1900,
        loop: false,

        onShow: function (n) {

          nodes.forEach(
            function (b, k) {

              b.classList.toggle(
                'is-on',
                k === n
              );

              b.classList.toggle(
                'is-past',
                k < n
              );

              b.setAttribute(
                'aria-pressed',
                k === n
                  ? 'true'
                  : 'false'
              );

            }
          );


          var own =
            [0, 1, 1, 1, 2, 2][n];


          pills.forEach(
            function (p, k) {

              p.classList.toggle(
                'is-on',
                k === own
              );

            }
          );


          words.forEach(
            function (w, k) {

              w.classList.toggle(
                'is-on',
                k === n
              );

            }
          );

        }

      }
    );


    var run =
      d.querySelector(
        '.l3Jr__run'
      );

    var pin =
      run &&
      run.querySelector(
        '.l3Jr__pin'
      );

    var hdEl =
      d.getElementById('hd');

    var N =
      nodes.length;

    var cur = -1;

    var pinned = false;

    var sq = false;

    var lastTop = -1;


    var over =
      run &&
      run.closest('.l3Over');


    function rr() {

      if (!over) {
        return run.getBoundingClientRect();
      }

      var t =
        over.getBoundingClientRect().top +
        run.offsetTop;

      return {
        top: t,
        bottom: t + run.offsetHeight
      };

    }


    function topOff() {

      var c =
        hdEl &&
        getComputedStyle(hdEl);

      var b =
        (
          c &&
          (
            c.position === 'fixed' ||
            c.position === 'sticky'
          )
        )
          ? Math.max(
              0,
              hdEl.getBoundingClientRect().bottom
            )
          : 0;

      return b + 12;

    }


    function progress() {

      var vh =
        innerHeight;


      if (pinned) {

        var r = rr();

        var span =
          run.offsetHeight -
          pin.offsetHeight;

        return span > 0
          ? (topOff() - r.top) / span
          : 0;

      }


      var sr =
        jr.getBoundingClientRect();

      return (
        vh * .85 -
        (
          sr.top +
          sr.height / 2
        )
      ) / (
        vh * .55
      );

    }


    function scrub() {

      sq = false;

      if (
        !run ||
        still ||
        !jr.offsetWidth
      ) {
        return;
      }


      var t = topOff();


      if (t !== lastTop) {

        if (
          rr().top >
          t + 40
        ) {

          layout();

          return;

        }


        if (
          rr().bottom <= t
        ) {

          layout();

          return;

        }


        var keep =
          Math.max(
            0,
            Math.min(
              1,
              progress()
            )
          );


        layout();


        if (pinned) {

          var r2 = rr();

          scrollTo({
            top:
              Math.round(
                scrollY +
                r2.top -
                topOff() +
                keep *
                (
                  run.offsetHeight -
                  pin.offsetHeight
                )
              ),

            behavior:
              'instant'
          });

        }

        return;

      }


      var pr =
        Math.max(
          0,
          Math.min(
            1,
            progress()
          )
        );


      var fp =
        Math.min(
          1,
          pr / 0.92
        );


      rail.style.setProperty(
        '--p',
        fp.toFixed(4)
      );


      var n =
        Math.min(
          N - 1,
          Math.floor(
            fp *
            (N - 1) +
            1e-6
          )
        );


      if (n !== cur) {

        cur = n;

        jrSeq.go(n);

      }

    }


    function layout() {

      if (
        !run ||
        still
      ) {
        return;
      }

      layout2();

    }


    function layout2() {

      if (
        pinned &&
        run.classList.contains(
          'is-pinned'
        ) &&
        jr.offsetWidth
      ) {

        var t0 =
          topOff();

        var oth =
          pin.offsetHeight -
          jr.offsetHeight;

        var hh =
          Math.min(
            jr.offsetWidth *
              (
                innerWidth <= 900
                  ? 5 / 4
                  : 8 / 21
              ),
            innerHeight -
              t0 -
              12 -
              oth
          );


        if (hh >= 180) {

          lastTop = t0;

          jr.style.height =
            Math.round(hh) + 'px';


          run.style.height =
            Math.round(
              oth +
              Math.round(hh) +
              N *
              Math.max(
                150,
                innerHeight * .36
              )
            ) + 'px';


          scrub();

          return;

        }

      }


      lastTop = topOff();

      jr.style.height = '';

      run.style.height = '';

      run.classList.remove(
        'is-pinned'
      );

      pinned = false;


      if (!jr.offsetWidth) {
        return;
      }


      var avail =
        innerHeight -
        topOff() -
        12;


      var other =
        pin.offsetHeight -
        jr.offsetHeight;


      var h =
        Math.min(
          jr.offsetWidth *
            (
              innerWidth <= 900
                ? 5 / 4
                : 8 / 21
            ),
          avail - other
        );


      if (h >= 180) {

        pinned = true;

        run.classList.add(
          'is-pinned'
        );

        jr.style.height =
          Math.round(h) + 'px';


        run.style.height =
          Math.round(
            pin.offsetHeight +
            N *
            Math.max(
              150,
              innerHeight * .36
            )
          ) + 'px';

      }


      run.classList.toggle(
        'is-flow',
        !pinned
      );


      var pl =
        run.querySelector(
          '.l3Pill'
        );


      if (pl) {

        if (innerWidth <= 900) {

          pl.tabIndex = 0;

          pl.setAttribute(
            'role',
            'group'
          );

          pl.setAttribute(
            'aria-label',
            'The Limelight ecosystem'
          );

        } else {

          pl.removeAttribute(
            'tabindex'
          );

          pl.removeAttribute(
            'role'
          );

          pl.removeAttribute(
            'aria-label'
          );

        }

      }


      scrub();

    }


    nodes.forEach(
      function (b, k) {

        b.addEventListener(
          'click',
          function () {

            var pr =
              Math.min(
                .97,
                k / (N - 1) * .92 +
                (k ? .01 : 0)
              );

            var y;


            if (
              still ||
              !run
            ) {

              cur = k;

              jrSeq.go(k);

              rail.style.setProperty(
                '--p',
                (
                  k / (N - 1)
                ).toFixed(4)
              );

              return;

            }


            if (pinned) {

              var r = rr();

              y =
                scrollY +
                r.top -
                topOff() +
                pr *
                (
                  run.offsetHeight -
                  pin.offsetHeight
                );

            } else {

              var sr =
                jr.getBoundingClientRect();

              var vh =
                innerHeight;

              y =
                scrollY +
                sr.top +
                sr.height / 2 -
                vh * .85 +
                pr *
                vh * .55;

            }


            scrollTo({
              top: Math.max(
                0,
                Math.round(y)
              ),
              behavior: 'smooth'
            });

          }
        );

      }
    );


    cur = 0;

    jrSeq.go(0);


    if (!still) {

      addEventListener(
        'scroll',
        function () {

          if (!sq) {

            sq = true;

            requestAnimationFrame(
              scrub
            );

          }

        },
        {
          passive: true
        }
      );


      addEventListener(
        'resize',
        layout
      );

      addEventListener(
        'load',
        layout
      );

      layout();


      if (
        'ResizeObserver' in window
      ) {

        var rq = false;

        var ro =
          new ResizeObserver(
            function () {

              if (!rq) {

                rq = true;

                requestAnimationFrame(
                  function () {

                    rq = false;

                    layout();

                  }
                );

              }

            }
          );


        ro.observe(rail);

        var pillEl =
          d.querySelector(
            '.l3Pill'
          );

        if (pillEl) {
          ro.observe(pillEl);
        }

      }


      if (
        d.fonts &&
        d.fonts.ready
      ) {

        d.fonts.ready.then(
          layout
        );

      }

    }

  }


  /* =========================================
     PROCESS DOTS HEIGHT
  ========================================= */

  (function () {

    var dt =
      d.querySelector(
        '.l3Pr__dots'
      );

    if (!dt) {
      return;
    }


    var host =
      dt.parentElement;

    var q = false;


    function set() {

      q = false;

      if (dt.offsetHeight) {

        host.style.setProperty(
          '--l3DotsH',
          dt.offsetHeight + 'px'
        );

      }

    }


    function ask() {

      if (!q) {

        q = true;

        requestAnimationFrame(
          set
        );

      }

    }


    addEventListener(
      'resize',
      ask
    );

    addEventListener(
      'load',
      ask
    );


    if (
      'ResizeObserver' in window
    ) {

      new ResizeObserver(
        ask
      ).observe(dt);

    }


    set();

  })();


  /* =========================================
     PROCESS
  ========================================= */

  var prSteps =
    $$('.l3Step');

  var prIllos =
    $$('.l3Pr__stage .l3Illo');

  var prDots =
    $$('.l3Pr__dots button');

  var prCount =
    d.querySelector(
      '.l3Pr__count span'
    );

  var prName =
    d.querySelector(
      '.l3Pr__name'
    );


  function prSet(n) {

    prIllos.forEach(
      function (s, k) {

        s.classList.toggle(
          'is-on',
          k === n
        );

      }
    );


    prDots.forEach(
      function (b, k) {

        b.classList.toggle(
          'is-on',
          k === n
        );

        b.classList.toggle(
          'is-past',
          k < n
        );

      }
    );


    if (prCount) {

      prCount.textContent =
        ('0' + (n + 1))
        .slice(-2);

    }


    if (prName) {

      if (prSteps[n]) {

        prName.textContent =
          prSteps[n]
            .getAttribute(
              'data-name'
            );

      }

    }

  }


  if (prSteps.length) {

    prSet(0);


    if (
      'IntersectionObserver' in window
    ) {

      var pio =
        new IntersectionObserver(
          function (es) {

            es.forEach(
              function (e) {

                if (
                  e.isIntersecting
                ) {

                  prSet(
                    prSteps.indexOf(
                      e.target
                    )
                  );

                }

              }
            );

          },
          {
            rootMargin:
              '-45% 0px -45% 0px'
          }
        );


      prSteps.forEach(
        function (s) {

          pio.observe(s);

        }
      );

    }


    prDots.forEach(
      function (b, k) {

        b.addEventListener(
          'click',
          function () {

            var top =
              prSteps[k]
                .getBoundingClientRect()
                .top +
              scrollY -
              (
                innerHeight * .5
              ) +
              prSteps[k]
                .offsetHeight * .5;


            scrollTo({
              top: top,
              behavior:
                still
                  ? 'instant'
                  : 'smooth'
            });

          }
        );

      }
    );

  }


  /* =========================================
     ONE SHOT IN VIEW
  ========================================= */

  if (
    'IntersectionObserver' in window
  ) {

    var vio =
      new IntersectionObserver(
        function (es) {

          es.forEach(
            function (e) {

              var el =
                e.target;


              if (
                el.classList.contains(
                  'l3Proof'
                )
              ) {

                if (
                  e.isIntersecting &&
                  !el.dataset.done
                ) {

                  el.dataset.done = 1;

                  $$(
                    '[data-n]',
                    el
                  ).forEach(
                    countUp
                  );

                }

              } else if (
                el === hero
              ) {

                if (
                  e.isIntersecting
                ) {

                  if (
                    film &&
                    !film.running
                  ) {

                    film.start();

                  }

                } else {

                  if (film) {
                    film.stop();
                  }

                }

              } else if (
                el.classList.contains(
                  'l3St__bars'
                )
              ) {

                if (
                  e.isIntersecting
                ) {

                  el.classList.add(
                    'is-in'
                  );

                }

              }

            }
          );

        },
        {
          threshold: .35
        }
      );


    $$('.l3Proof,.l3St__bars')
      .forEach(
        function (el) {

          vio.observe(el);

        }
      );


    if (hero) {
      vio.observe(hero);
    }


  } else {

    if (film) {
      film.start();
    }

    $$('.l3St__bars')
      .forEach(
        function (el) {

          el.classList.add(
            'is-in'
          );

        }
      );

  }


  /* =========================================
     CELEBRITY CAROUSEL
  ========================================= */

  $$('.l3Car').forEach(
    function (c) {

      var tr =
        c.querySelector(
          '.l3Car__track'
        );

      var b =
        $$('.l3Car__nav button', c);


      function step(dir) {

        var card =
          tr.firstElementChild;

        var w =
          card
            ? card.getBoundingClientRect()
                .width + 16
            : 300;


        tr.scrollBy({
          left: dir * w,
          behavior:
            still
              ? 'instant'
              : 'smooth'
        });

      }


      if (b[0]) {

        b[0].addEventListener(
          'click',
          function () {
            step(-1);
          }
        );

      }


      if (b[1]) {

        b[1].addEventListener(
          'click',
          function () {
            step(1);
          }
        );

      }

    }
  );


  /* =========================================
     PILLARS ACCORDION
  ========================================= */

  $$('.l3Pillar').forEach(
    function (pl, k) {

      var b =
        pl.querySelector(
          '.l3Pillar__hd'
        );


      if (!b) {
        return;
      }


      function set(o) {

        pl.classList.toggle(
          'is-open',
          o
        );

        b.setAttribute(
          'aria-expanded',
          o
            ? 'true'
            : 'false'
        );

      }


      set(k === 0);


      b.addEventListener(
        'click',
        function () {

          set(
            !pl.classList.contains(
              'is-open'
            )
          );

        }
      );

    }
  );


  /* =========================================
     LEADERSHIP TAP
  ========================================= */
  // $$('.l3P.leadership')
  //   .forEach(
  //     function (p) {

  //       if (
  //         p.classList.contains(
  //           'l3P--bio'
  //         )
  //       ) {

  //         p.setAttribute(
  //           'aria-expanded',
  //           'false'
  //         );

  //       }


  //       p.addEventListener(
  //         'click',
  //         function (ev) {

  //           var r =
  //             d.querySelector(
  //               '.l3Ld__row'
  //             );
  //         ev.preventDefault();
  //         ev.stopImmediatePropagation();
 
  //           if (
  //             ev.detail > 0 &&
  //             r &&
  //             r.classList.contains(
  //               'is-js'
  //             ) &&
  //             r.contains(p)
  //           ) {

  //             return;

  //           }


  //           var open =
  //             p.classList.contains(
  //               'is-open'
  //             );


  //           $$('.l3P.is-open')
  //             .forEach(
  //               function (x) {

  //                 x.classList.remove(
  //                   'is-open'
  //                 );

  //                 if (
  //                   x.hasAttribute(
  //                     'aria-expanded'
  //                   )
  //                 ) {

  //                   x.setAttribute(
  //                     'aria-expanded',
  //                     'false'
  //                   );

  //                 }

  //               }
  //             );


  //           if (!open) {

  //             p.classList.add(
  //               'is-open'
  //             );

  //             if (
  //               p.hasAttribute(
  //                 'aria-expanded'
  //               )
  //             ) {

  //               p.setAttribute(
  //                 'aria-expanded',
  //                 'true'
  //               );

  //             }

  //           }

  //         }
  //       );


  //       p.addEventListener(
  //         'keydown',
  //         function (ev) {

  //           if (
  //             ev.key === 'Enter' ||
  //             ev.key === ' '
  //           ) {

  //             ev.preventDefault();

  //             p.click();

  //           }

  //         }
  //       );

  //     }
  //   );



  /* =========================================
     LEADERSHIP DESKTOP HOVER
  ========================================= */

  var ldRow =
    d.querySelector(
      '.l3Ld__row'
    );


  if (
    ldRow &&
    window.matchMedia
  ) {

    var ldMq =
      matchMedia(
        '(min-width:901px) and (hover:hover) and (pointer:fine)'
      );

    var ldT = 0;


    function ldSet(p) {

      $$('.l3P', ldRow)
        .forEach(
          function (x) {

            var on =
              x === p;

            x.classList.toggle(
              'is-open',
              on
            );


            if (
              x.hasAttribute(
                'aria-expanded'
              )
            ) {

              x.setAttribute(
                'aria-expanded',
                on
                  ? 'true'
                  : 'false'
              );

            }

          }
        );

    }


    function ldSync() {

      ldRow.classList.toggle(
        'is-js',
        ldMq.matches
      );

    }


    ldSync();


    if (
      ldMq.addEventListener
    ) {

      ldMq.addEventListener(
        'change',
        ldSync
      );

    }


    $$('.l3P', ldRow)
      .forEach(
        function (p) {

          p.addEventListener(
            'pointerenter',
            function (ev) {

              if (
                !ldMq.matches ||
                ev.pointerType !== 'mouse'
              ) {
                return;
              }


              clearTimeout(ldT);


              var any =
                ldRow.querySelector(
                  '.l3P.is-open'
                );


              ldT =
                setTimeout(
                  function () {

                    ldSet(
                      p.classList.contains(
                        'l3P--bio'
                      )
                        ? p
                        : null
                    );

                  },
                  any ? 40 : 90
                );

            }
          );

        }
      );


    ldRow.addEventListener(
      'pointerleave',
      function (ev) {

        if (
          !ldMq.matches ||
          ev.pointerType !== 'mouse'
        ) {
          return;
        }


        clearTimeout(ldT);


        ldT =
          setTimeout(
            function () {

              ldSet(null);

            },
            160
          );

      }
    );

  }


  /* =========================================
     TABS
  ========================================= */

  var tabs =
    $$('.l3Tab');

  var panels =
    $$('.l3Panel');

  var bar =
    d.querySelector(
      '.l3Tabs'
    );

  var hd =
    d.querySelector('.shopify-section-group-header-group');

  var l3 =
    d.querySelector('.l3');


  function hdCover() {

    if (!hd) {
      return 0;
    }


    var cs =
      getComputedStyle(hd);


    if (
      cs.position !== 'fixed' &&
      cs.position !== 'sticky'
    ) {

      return 0;

    }


    return Math.max(
      0,
      Math.round(
        hd.getBoundingClientRect().bottom
      )
    );

  }


  var tq = false;


  function syncTop() {

    tq = false;

    if (l3) {

      l3.style.setProperty(
        '--l3Top',
        hdCover() + 'px'
      );

    }

  }


  function askTop() {

    if (!tq) {

      tq = true;

      requestAnimationFrame(
        syncTop
      );

    }

  }


  addEventListener(
    'scroll',
    askTop,
    {
      passive: true
    }
  );


  addEventListener(
    'resize',
    askTop
  );


  syncTop();


  if (
    hd &&
    'MutationObserver' in window
  ) {

    new MutationObserver(
      askTop
    ).observe(
      hd,
      {
        attributes: true,
        attributeFilter: [
          'class',
          'style'
        ]
      }
    );

  }


  function activate(id, scroll) {

    tabs.forEach(
      function (t) {

        var on =
          t.getAttribute(
            'aria-controls'
          ) === id;


        t.setAttribute(
          'aria-selected',
          on
            ? 'true'
            : 'false'
        );


        t.tabIndex =
          on ? 0 : -1;

      }
    );


    panels.forEach(
      function (p) {

        p.hidden =
          p.id !== id;


        var hx =
          p.querySelector(
            '[data-l3h]'
          );


        if (hx) {

          var want =
            p.hidden
              ? 'H2'
              : 'H1';


          if (
            hx.tagName !== want
          ) {

            var n =
              d.createElement(
                want
              );


            [].slice.call(
              hx.attributes
            ).forEach(
              function (at) {

                n.setAttribute(
                  at.name,
                  at.value
                );

              }
            );


            while (
              hx.firstChild
            ) {

              n.appendChild(
                hx.firstChild
              );

            }


            hx.parentNode.replaceChild(
              n,
              hx
            );

          }

        }

      }
    );


    if (film) {

      if (
        id === 'about-limelight'
      ) {

        film.start();

      } else {

        film.stop();

      }

    }


    $$('.l3Sw__b')
      .forEach(
        function (b) {

          if (
            b.getAttribute(
              'data-goto'
            ) === id
          ) {

            b.setAttribute(
              'aria-current',
              'page'
            );

          } else {

            b.removeAttribute(
              'aria-current'
            );

          }

        }
      );


    if (scroll) {

      if (
        history.pushState &&
        location.hash !== '#' + id
      ) {

        history.pushState(
          {
            l3: id
          },
          '',
          '#' + id
        );

      }

    } else if (
      history.replaceState
    ) {

      history.replaceState(
        {
          l3: id
        },
        '',
        '#' + id
      );

    }


    if (scroll) {

      scrollTo({
        top: 0,
        behavior: 'instant'
      });


      var hh =
        d.querySelector(
          '#' + id +
          ' [data-l3h]'
        );


      if (hh) {

        hh.setAttribute(
          'tabindex',
          '-1'
        );


        try {

          hh.focus({
            preventScroll: true
          });

        } catch (_) {

          hh.focus();

        }

      }

    }


    dispatchEvent(
      new Event('resize')
    );

  }


  tabs.forEach(
    function (t, k) {

      t.addEventListener(
        'click',
        function () {

          activate(
            t.getAttribute(
              'aria-controls'
            ),
            true
          );

        }
      );


      t.addEventListener(
        'keydown',
        function (ev) {

          if (
            ev.key === 'ArrowRight' ||
            ev.key === 'ArrowLeft'
          ) {

            var n =
              tabs[
                (
                  k +
                  (
                    ev.key ===
                    'ArrowRight'
                      ? 1
                      : tabs.length - 1
                  )
                ) %
                tabs.length
              ];


            n.focus();

            n.click();

          }

        }
      );

    }
  );


  $$('[data-goto]')
    .forEach(
      function (b) {

        b.addEventListener(
          'click',
          function () {

            activate(
              b.getAttribute(
                'data-goto'
              ),
              true
            );

          }
        );

      }
    );


  var want =
    (location.hash || '')
      .slice(1);


  if (
    'scrollRestoration' in history
  ) {

    history.scrollRestoration =
      'manual';

  }


  /* =========================================
     BACK / FORWARD TAB NAVIGATION
  ========================================= */

  addEventListener(
    'popstate',
    function () {

      var h =
        (location.hash || '')
          .slice(1) ||
        'about-limelight';


      var el =
        d.getElementById(h);


      if (
        el &&
        el.classList.contains(
          'l3Panel'
        )
      ) {

        activate(
          h,
          false
        );


        scrollTo({
          top: 0,
          behavior: 'instant'
        });


        var hh =
          el.querySelector(
            '[data-l3h]'
          );


        if (hh) {

          hh.setAttribute(
            'tabindex',
            '-1'
          );


          try {

            hh.focus({
              preventScroll: true
            });

          } catch (_) {

            hh.focus();

          }

        }

      }

    }
  );


  /* =========================================
     DEEP LINK
  ========================================= */

  (function () {

    var el =
      want &&
      d.getElementById(want);


    if (
      !el ||
      el.classList.contains(
        'l3Panel'
      )
    ) {

      return;

    }


    var p =
      el.closest(
        '.l3Panel'
      );


    if (
      p &&
      p.hidden
    ) {

      activate(
        p.id,
        false
      );

    }


    var user = false;


    [
      'wheel',
      'touchstart',
      'keydown',
      'mousedown'
    ].forEach(
      function (t) {

        addEventListener(
          t,
          function () {

            user = true;

          },
          {
            passive: true,
            once: true
          }
        );

      }
    );


    function go() {

      if (user) {
        return;
      }


      var hb =
        hd
          ? Math.max(
              0,
              hd.getBoundingClientRect()
                .bottom
            )
          : 0;


      scrollTo({
        top: Math.max(
          0,
          Math.round(
            el.getBoundingClientRect().top +
            scrollY -
            (hb || 104) -
            12
          )
        ),

        behavior:
          'instant'
      });

    }


    addEventListener(
      'load',
      function () {

        requestAnimationFrame(
          function () {

            go();

            requestAnimationFrame(
              go
            );

          }
        );


        setTimeout(
          go,
          450
        );

        setTimeout(
          go,
          1200
        );

      }
    );

  })();


  /* =========================================
     TAB HASH ON INITIAL LOAD
  ========================================= */

  if (
    want &&
    d.getElementById(want) &&
    d.getElementById(want)
      .classList.contains(
        'l3Panel'
      )
  ) {

    activate(
      want,
      false
    );


    addEventListener(
      'load',
      function () {

        if (scrollY < 400) {

          scrollTo({
            top: 0,
            behavior: 'instant'
          });

        }

      }
    );

  }


  /* =========================================
     PARALLAX
  ========================================= */

  var px =
    $$('[data-speed]');


  if (
    px.length &&
    !still
  ) {

    var pq = false;


    var prun =
      function () {

        pq = false;


        var vh =
          innerHeight;

        var k =
          innerWidth <= 900
            ? 0
            : 1;


        if (!k) {

          px.forEach(
            function (el) {

              el.style.transform =
                '';

            }
          );

          return;

        }


        px.forEach(
          function (el) {

            var host =
              el.closest(
                '[data-px]'
              );


            if (!host) {
              return;
            }


            var r =
              host.getBoundingClientRect();


            if (
              r.bottom < -200 ||
              r.top > vh + 200
            ) {

              return;

            }


            el.style.transform =
              'translate3d(0,' +
              (
                (
                  vh / 2 -
                  (
                    r.top +
                    r.height / 2
                  )
                ) *
                parseFloat(
                  el.getAttribute(
                    'data-speed'
                  )
                )
              ).toFixed(1) +
              'px,0)';

          }
        );

      };


    addEventListener(
      'scroll',
      function () {

        if (!pq) {

          pq = true;

          requestAnimationFrame(
            prun
          );

        }

      },
      {
        passive: true
      }
    );


    addEventListener(
      'resize',
      prun
    );


    prun();

  }


  /* =========================================
     CARD 05 DRIFT
  ========================================= */

  (function () {

    var c5 =
      $$('.l3Card--5')[0];

    var bd =
      c5 &&
      $$('.l3Card__body', c5)[0];


    if (
      !c5 ||
      !bd ||
      still
    ) {

      return;

    }


    var q = false;


    function run() {

      q = false;


      if (
        getComputedStyle(c5)
          .gridTemplateColumns
          .split(' ')
          .length < 2
      ) {

        bd.style.transform =
          '';

        return;

      }


      var r =
        c5.getBoundingClientRect();

      var vh =
        innerHeight;


      if (
        r.bottom < -200 ||
        r.top > vh + 200
      ) {

        return;

      }


      var slack =
        Math.max(
          0,
          c5.clientHeight -
          bd.offsetHeight
        );


      var t =
        Math.max(
          0,
          Math.min(
            1,
            (
              r.top +
              r.height / 2 -
              vh * .45
            ) /
            (vh * .5)
          )
        );


      bd.style.transform =
        'translate3d(0,' +
        (
          -slack * t
        ).toFixed(1) +
        'px,0)';

    }


    addEventListener(
      'scroll',
      function () {

        if (!q) {

          q = true;

          requestAnimationFrame(
            run
          );

        }

      },
      {
        passive: true
      }
    );


    addEventListener(
      'resize',
      run
    );


    run();

  })();


  /* =========================================
     POWER BEHIND SCROLL OVER
  ========================================= */

  (function () {

    var pw =
      d.getElementById(
        'the-power-behind-limelight'
      );


    if (
      !pw ||
      still ||
      !root.classList.contains(
        'l3Js'
      )
    ) {

      return;

    }


    var q = false;


    function fit() {

      q = false;


      if (!pw.offsetHeight) {
        return;
      }


      pw.style.setProperty(
        '--l3OverTop',
        Math.min(
          0,
          innerHeight -
          pw.offsetHeight
        ) + 'px'
      );

    }


    function ask() {

      if (!q) {

        q = true;

        requestAnimationFrame(
          fit
        );

      }

    }


    addEventListener(
      'resize',
      ask
    );

    addEventListener(
      'load',
      ask
    );


    if (
      'ResizeObserver' in window
    ) {

      new ResizeObserver(
        ask
      ).observe(pw);

    }


    fit();

  })();


  /* =========================================
     FOUNDER GEM REVEAL
  ========================================= */

  $$('[data-gem]')
    .forEach(
      function (ph) {

        var host =
          ph.closest('.l3F');

        var parts =
          $$('[data-sx]', host);


        if (still) {

          ph.style.clipPath =
            'none';

          return;

        }


        var q = false;


        function run() {

          q = false;


          var r =
            ph.getBoundingClientRect();

          var vh =
            innerHeight;


          var t =
            Math.max(
              0,
              Math.min(
                1,
                (vh - r.top) /
                (vh * .8)
              )
            );


          t =
            1 -
            Math.pow(
              1 - t,
              2
            );


          function L(a, b) {

            return (
              a +
              (b - a) * t
            ).toFixed(2) + '%';

          }


          ph.style.clipPath =
            'polygon(' +
            L(50, 0) + ' ' +
            L(35, 0) + ',' +
            L(65, 100) + ' ' +
            L(50, 0) + ',' +
            L(50, 100) + ' ' +
            L(65, 100) + ',' +
            L(35, 0) + ' ' +
            L(50, 100) +
            ')';


          var hr =
            host.getBoundingClientRect();


          var off =
            (
              vh / 2 -
              (
                hr.top +
                hr.height / 2
              )
            );


          var k =
            innerWidth <= 900
              ? .4
              : 1;


          var room =
            Math.max(
              0,
              (
                parseFloat(
                  getComputedStyle(
                    host
                  ).columnGap
                ) || 24
              ) - 10
            );


          parts.forEach(
            function (sp) {

              var tx =
                off *
                parseFloat(
                  sp.getAttribute(
                    'data-sx'
                  )
                ) *
                k;


              if (
                tx < -room
              ) {

                tx = -room;

              }


              sp.style.transform =
                'translate3d(' +
                tx.toFixed(1) +
                'px,0,0)';

            }
          );

        }


        addEventListener(
          'scroll',
          function () {

            if (!q) {

              q = true;

              requestAnimationFrame(
                run
              );

            }

          },
          {
            passive: true
          }
        );


        addEventListener(
          'resize',
          run
        );


        run();

      }
    );


  /* =========================================
     SENTENCE WORD LIGHT
  ========================================= */

  $$('[data-lit]')
    .forEach(
      function (pEl) {

        var ws =
          $$('span', pEl);


        if (still) {

          ws.forEach(
            function (w) {

              w.classList.add(
                'is-lit'
              );

            }
          );

          return;

        }


        var q = false;


        function run() {

          q = false;


          var r =
            pEl.getBoundingClientRect();

          var vh =
            innerHeight;


          var t =
            Math.max(
              0,
              Math.min(
                1,
                (
                  vh * .88 -
                  r.top
                ) /
                (
                  r.height +
                  vh * .38
                )
              )
            );


          var n =
            Math.round(
              t * ws.length
            );


          ws.forEach(
            function (w, i) {

              w.classList.toggle(
                'is-lit',
                i < n
              );

            }
          );

        }


        addEventListener(
          'scroll',
          function () {

            if (!q) {

              q = true;

              requestAnimationFrame(
                run
              );

            }

          },
          {
            passive: true
          }
        );


        addEventListener(
          'resize',
          run
        );


        run();

      }
    );


  /* =========================================
     PRESS STRIP PAUSE
  ========================================= */

  $$('.l3News__pause')
    .forEach(
      function (b) {

        var strip =
          b.parentElement.querySelector(
            '.l3News'
          );


        if (!strip) {
          return;
        }


        b.addEventListener(
          'click',
          function () {

            var on =
              !strip.classList.contains(
                'is-paused'
              );


            strip.classList.toggle(
              'is-paused',
              on
            );


            b.setAttribute(
              'aria-pressed',
              on
                ? 'true'
                : 'false'
            );


            b.textContent =
              on
                ? 'Play'
                : 'Pause';

          }
        );

      }
    );


  /* =========================================
     DIFFERENCE CARD DIALOG
  ========================================= */

  (function () {

    var dlg =
      d.querySelector(
        '.l3Dlg'
      );


    if (
      !dlg ||
      !dlg.showModal
    ) {

      return;

    }


    var from = null;


    function q(s) {

      return dlg.querySelector(s);

    }


    $$('.l3Card__more')
      .forEach(
        function (b) {

          b.addEventListener(
            'click',
            function () {

              var c =
                b.closest(
                  '.l3Card'
                );


              if (!c) {
                return;
              }


              var h =
                c.querySelector(
                  'h3'
                );


              if (!h) {
                return;
              }


              h =
                h.cloneNode(true);


              $$('.l3Vh', h)
                .forEach(
                  function (x) {
                    x.remove();
                  }
                );


              var num =
                c.querySelector(
                  '.l3Card__num'
                );


              var lab =
                c.querySelector(
                  '.l3Lab'
                );


              var body =
                c.querySelector(
                  '.l3Card__body p'
                );


              q('.l3Dlg__n')
                .textContent =
                num
                  ? num.textContent
                  : '';


              q('#l3DlgT')
                .textContent =
                h.textContent;


              q('.l3Dlg__k')
                .textContent =
                lab
                  ? lab.textContent
                  : '';


              q('.l3Dlg__p')
                .textContent =
                body
                  ? body.textContent
                  : '';


              from = b;

              dlg.showModal();

              d.documentElement
                .classList.add(
                  'l3NoScroll'
                );

            }
          );

        }
      );


    var close =
      q('.l3Dlg__x');


    if (close) {

      close.addEventListener(
        'click',
        function () {

          dlg.close();

        }
      );

    }


    dlg.addEventListener(
      'click',
      function (ev) {

        if (
          ev.target === dlg
        ) {

          dlg.close();

        }

      }
    );


    dlg.addEventListener(
      'close',
      function () {

        d.documentElement
          .classList.remove(
            'l3NoScroll'
          );


        if (from) {
          from.focus();
        }

      }
    );

  })();


  /* =========================================
     PROCESS MOBILE NAV
  ========================================= */

  (function () {

    var tr =
      d.getElementById(
        'l3PrSteps'
      );
    var nav =
      d.querySelector(
        '.l3Pr__mnav'
      );


    if (
      !tr ||
      !nav
    ) {

      return;

    }


    var steps =
      $$('.l3Step', tr);

    var cnt =
      nav.querySelector('b');

    var bs =
      $$('button', nav);

    var q = false;


    function idx() {

      if (!steps.length) {
        return 0;
      }


      var w =
        steps[0].offsetWidth +
        parseFloat(
          getComputedStyle(
            tr
          ).columnGap || 0
        );


      return Math.max(
        0,
        Math.min(
          steps.length - 1,
          Math.round(
            tr.scrollLeft / w
          )
        )
      );

    }


    function gate(b, off) {

      if (!b) {
        return;
      }


      if (off) {

        b.setAttribute(
          'aria-disabled',
          'true'
        );

      } else {

        b.removeAttribute(
          'aria-disabled'
        );

      }

    }


    function sync() {

      q = false;


      var i =
        idx();


      if (cnt) {

        cnt.textContent =
          ('0' + (i + 1))
            .slice(-2);

      }


      gate(
        bs[0],
        i === 0
      );

      gate(
        bs[1],
        i === steps.length - 1
      );

    }


    tr.addEventListener(
      'scroll',
      function () {

        if (!q) {

          q = true;

          requestAnimationFrame(
            sync
          );

        }

      },
      {
        passive: true
      }
    );


    bs.forEach(
      function (b) {

        b.addEventListener(
          'click',
          function () {

            if (
              b.getAttribute(
                'aria-disabled'
              ) === 'true'
            ) {

              return;

            }


            var i =
              Math.max(
                0,
                Math.min(
                  steps.length - 1,
                  idx() +
                  parseInt(
                    b.getAttribute(
                      'data-dir'
                    ),
                    10
                  )
                )
              );


            if (!steps[i]) {
              return;
            }


            tr.scrollTo({

              left:
                steps[i].offsetLeft -
                steps[0].offsetLeft,

              behavior:
               'smooth'

            });

          }
        );

      }
    );


    addEventListener(
      'resize',
      sync
    );


    sync();

  })();


  /* =========================================
     PHILOSOPHY READ MORE
  ========================================= */

  $$('.l3Ph2__more')
    .forEach(
      function (b) {

        var id =
          b.getAttribute(
            'aria-controls'
          );


        var box =
          id &&
          d.getElementById(id);


        if (!box) {
          return;
        }


        b.addEventListener(
          'click',
          function () {

            var open =
              box.classList.toggle(
                'is-open'
              );


            b.setAttribute(
              'aria-expanded',
              open
                ? 'true'
                : 'false'
            );


            b.textContent =
              open
                ? 'Read less'
                : 'Read more';

          }
        );

      }
    );


  /* =========================================
     AWARDS SEE ALL
  ========================================= */

var lwbuttons = d.querySelectorAll('.l3Aw__all'); 

lwbuttons.forEach(
      function (b) {

        var id =
          b.getAttribute(
            'aria-controls'
          );


        var ul =
          id &&
          d.getElementById(id);


        if (!ul) {
          return;
        }


        b.addEventListener(
          'click',
          function (e) {

          e.preventDefault();
          e.stopImmediatePropagation();
            var open =
              ul.classList.toggle(
                'is-open'
              );


            b.setAttribute(
              'aria-expanded',
              open
                ? 'true'
                : 'false'
            );


            b.textContent =
              open
                ? 'Show fewer'
                : 'See all awards';


            if (!open) {

              var r =
                b.getBoundingClientRect();


              if (
                r.top < 0 ||
                r.bottom > innerHeight
              ) {

                b.scrollIntoView({
                  block: 'center',
                  behavior: 'instant'
                });

              }

            }

          }
        );

      }
    );


  /* =========================================
     AWARDS HOVER IMAGE
  ========================================= */

  $$('.l3Aw')
    .forEach(
      function (box) {

        var rows =
          $$('.l3Aw__row', box);

        var figs =
          $$('.l3Aw__peek figure', box);

        var peek =
          box.querySelector(
            '.l3Aw__peek'
          );


        if (!peek) {
          return;
        }


        function set(i) {

          rows.forEach(
            function (r, k) {

              r.classList.toggle(
                'is-on',
                k === i
              );

            }
          );


          figs.forEach(
            function (f, k) {

              f.classList.toggle(
                'is-on',
                k === i
              );

            }
          );

        }


        box.addEventListener(
          'mousemove',
          function (ev) {

            var b =
              box.getBoundingClientRect();

            var w =
              peek.offsetWidth;

            var h =
              peek.offsetHeight;


            var x =
              ev.clientX -
              b.left +
              32;


            var y =
              ev.clientY -
              b.top +
              24;


            if (
              x + w >
              b.width
            ) {

              x =
                ev.clientX -
                b.left -
                w -
                32;

            }


            peek.style.setProperty(
              '--x',
              Math.max(
                0,
                x
              ) + 'px'
            );


            peek.style.setProperty(
              '--y',
              y + 'px'
            );

          }
        );


        rows.forEach(
          function (r, i) {

            r.addEventListener(
              'mouseenter',
              function () {

                set(i);

                box.classList.add(
                  'is-peek'
                );

              }
            );


            r.addEventListener(
              'focus',
              function () {

                set(i);

              }
            );

          }
        );


        box.addEventListener(
          'mouseleave',
          function () {

            box.classList.remove(
              'is-peek'
            );

            set(-1);

          }
        );

      }
    );

})();